import React, { useEffect, useState } from "react";
import { useI18n } from "../../i18n/I18nContext";
import { api } from "../../lib/api";
import { ChevronDown } from "lucide-react";

export default function FAQ() {
  const { t, isAr } = useI18n();
  const [faqs, setFaqs] = useState([]);
  const [open, setOpen] = useState(null);
  useEffect(() => { api.get("/faq").then((r) => setFaqs(r.data)).catch(() => {}); }, []);
  return (
    <div className="mx-auto max-w-3xl px-4 py-12 sm:px-8">
      <h1 className="text-3xl font-bold text-slate-900 sm:text-4xl">{t("nav.faq")}</h1>
      <div className="mt-8 space-y-3">
        {faqs.map((f, i) => (
          <div key={f.id} className="overflow-hidden rounded-xl border border-border bg-white">
            <button onClick={() => setOpen(open === i ? null : i)} data-testid={`faq-${i}`} className="flex w-full items-center justify-between px-5 py-4 text-start font-semibold text-slate-900">
              {isAr ? f.q_ar : f.q_en}
              <ChevronDown className={`h-5 w-5 text-slate-400 transition-transform ${open === i ? "rotate-180" : ""}`} />
            </button>
            {open === i && <div className="border-t border-border px-5 py-4 text-sm text-slate-600">{isAr ? f.a_ar : f.a_en}</div>}
          </div>
        ))}
      </div>
    </div>
  );
}
